import { MAX_RUNS_PER_PLAY, OUTS_PER_INNING } from "../../constants/game";
import { ResultsEdited } from "../../utils/autoResults";
import { BaserunnerFlags } from "../../utils/pitchTagging";
import { BaseRunners } from "../BaseRunners";
import { ResultRow, Stepper } from "../ResultControls";

type ResultsSectionProps = {
  runsScored: number;
  outsRecorded: number;
  baseRunners: BaserunnerFlags;
  edited: ResultsEdited;
  onRunsScoredChange: (value: number) => void;
  onOutsRecordedChange: (value: number) => void;
  onBaseRunnersChange: (value: BaserunnerFlags) => void;
};

export const ResultsSection = ({
  runsScored,
  outsRecorded,
  baseRunners,
  edited,
  onRunsScoredChange,
  onOutsRecordedChange,
  onBaseRunnersChange,
}: ResultsSectionProps) => (
  <div className="space-y-2">
    <ResultRow
      label="Resulting Baserunners"
      isAuto={!edited.baseRunners}
      badgeTestId="pitch-tagging-auto-badge"
      badgeField="base-runners"
    >
      {/* The diamond's box fits its bases exactly: room above and below */}
      <div className="py-2">
        <BaseRunners
          data-testid="pitch-tagging-base-runners-panel"
          editable
          size="medium"
          baserunners={baseRunners}
          onChange={onBaseRunnersChange}
        />
      </div>
    </ResultRow>
    <ResultRow
      label="Runs Scored"
      isAuto={!edited.runsScored}
      badgeTestId="pitch-tagging-auto-badge"
      badgeField="runs-scored"
    >
      <Stepper
        value={runsScored}
        max={MAX_RUNS_PER_PLAY}
        onChange={onRunsScoredChange}
        valueTestId="pitch-tagging-runs-scored-value"
        incrementTestId="pitch-tagging-runs-scored-increment-button"
        decrementTestId="pitch-tagging-runs-scored-decrement-button"
      />
    </ResultRow>
    <ResultRow
      label="Outs Recorded"
      isAuto={!edited.outsRecorded}
      badgeTestId="pitch-tagging-auto-badge"
      badgeField="outs-recorded"
    >
      <Stepper
        value={outsRecorded}
        max={OUTS_PER_INNING}
        onChange={onOutsRecordedChange}
        valueTestId="pitch-tagging-outs-recorded-value"
        incrementTestId="pitch-tagging-outs-recorded-increment-button"
        decrementTestId="pitch-tagging-outs-recorded-decrement-button"
      />
    </ResultRow>
  </div>
);
